import { IApiError } from '@/models/apiError.model';
import { IUser } from '@/models/users.model';
import { IPagination } from '@/models/pagination.model';
import { TUserFiltersValues } from '../helpers/types';

export const USERS_LIST_SLICE_NAME = 'usersList';

export interface UsersListState {
  usersList: {
    items: IUser[];
    pagination?: IPagination | null;
  } | null;
  userDetails: IUser | null;
  isLoading: boolean;
  error: IApiError | null;
  userFilters: TUserFiltersValues | null;
}

export const initialState: UsersListState = {
  userDetails: null,
  usersList: null,
  isLoading: false,
  userFilters: null,
  error: null,
};
